import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form, message, DatePicker, Transfer } from 'antd';

import { Select, Input } from 'antd';
import { actions, reStart, asyncGetAll, asyncGet, changeTrankerSource} from './reducers';
import { formItemLayout, formatFormData } from './utils';
import { commendList } from '../../../utils/';
const FormItem = Form.Item;

class SetOrder extends React.Component {

    prop1 = {
        onLineC : "-1",
        osC: "-1",
    }
    state = {
        show: true,
    }
    componentDidMount() {
        // 获取客户端列表
        this.props.asyncGetAll();
    }
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const params = formatFormData(values);
                const { action, url, path, content, executeNow, timeStamp } = params;
                // 规则
                if (action == 1 || action == 2 || action == 8 || action == 11) {
                    if (!url || !path) {
                        message.error('url和path是必填项');
                        return null;
                    }
                }
                if (action == 0) {
                    if (!content) {
                        message.error('命令内容是必填项');
                        return null;
                    }
                }
                if (action == 3) {
                    if (!url && !path) {
                        message.error('url和path必须填一个');
                        return null;
                    }
                }
                if (action == 4) {
                    if (!path) {
                        message.error('path是必填项');
                        return null;
                    }
                }
                if (action == 5) {
                    if (!url) {
                        message.error('url是必填项');
                        return null;
                    }
                }
                if (action == 9 || action == 10) {
                    if (!packageName) {
                        message.error('packageName是必填项');
                        return null;
                    }
                }

                if (executeNow) {
                    params.timeStamp = '';
                }

                if (executeNow !== undefined && !executeNow) {
                    if (!timeStamp) {
                        message.error('请选择执行时间');
                        return null;
                    }
                }
                const { transferData } = this.props;
                const { selectedRowKeys = [] } = transferData;

                if (!selectedRowKeys.length) {
                    message.error('请选择目标客户端');
                    return null;
                }

                params.clientIds = selectedRowKeys;
                await this.props.reStart(params);
                this.props.form.resetFields();
                this.props.getTransferData({ selectedRowKeys: [] });
                this.props.modalHide();
                this.props.asyncGet();
            }
        });
    };
    handleSelectChange = value => {
        if (!value) {
            this.setState({show: true});
        } else {
            this.setState({show: false});
            this.props.form.setFieldsValue({
                timeStamp: '',
            });
        }
    }
    filterOption = (inputValue, option) => {
    /*    const [sId, cId] = inputValue.split('-');
        if (sId && cId) {
            return option.shelfId.indexOf(sId) > -1 && option.clientId.indexOf(cId) > -1;
        }
        if (sId) {
            return option.shelfId.indexOf(sId) > -1;
        }
        if (cId) {
            return option.clientId.indexOf(cId) > -1;
        }*/
        let  str = option.shelfId+"-"+option.clientId;
        return str.indexOf(inputValue) ==0;
    }

    handleChange = targetKeys => {
        this.props.getTransferData({ selectedRowKeys: targetKeys });
    }

    renderItem = item => {
        const customLabel = (
            <span span={6}>{item.shelfId}-{item.clientId}</span>
        );
        return {
            label: customLabel, // for displayed item
            value: item.shelfId, // for title and filter matching
        };
    }
    changeValue = (value, option) => {

        if(value == 'onLineC') {
            this.prop1.onLineC=option;
        }
        if(value == 'osC') {
            this.prop1.osC=option;
        }

        this.props.changeTrankerSource(this.prop1.onLineC,this.prop1.osC);
    }
    render() {
        const commendOptions = commendList.map(i => {
            return (<Option value={i.value}>{i.name}</Option>);
        });
        const { isModalShow, isLoading,  transferData ,listAllChild} = this.props;
        const { selectedRowKeys = [] } = transferData;
        const { show } = this.state;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="命令类型">
                            {getFieldDecorator('action')(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    {commendOptions}
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="命令内容">
                            {getFieldDecorator('content')(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="url">
                            {getFieldDecorator('url')(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="path">
                            {getFieldDecorator('path')(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                    <FormItem {...formItemLayout} label="包名">
                        {getFieldDecorator('packageName')(
                            <Input placeholder="请填写" style={{ width: '100%' }}/>,
                        )}
                    </FormItem>
                </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="重试次数">
                            {getFieldDecorator('retryTime')(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>


                    <Col span={24}>
                        <FormItem {...formItemLayout} label="执行时机">
                            {getFieldDecorator('executeNow', {
                                initialValue: true,
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择" onChange={this.handleSelectChange}>
                                    <Option value={true}>立即执行</Option>

                                    <Option value={false}>定时执行</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    {show ? <Col span={24}>
                        <FormItem {...formItemLayout} label="执行时间">
                            {getFieldDecorator('timeStamp')(
                                <DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    placeholder="选择时间"
                                />,
                            )}
                        </FormItem>
                    </Col> : ''}
                    <Col span={4} offset={3}><h4>客户端筛选条件：</h4></Col>
                    <Col span={1} >
                        <FormItem  label="状态">
                            {getFieldDecorator('onLine')(
                                <Select allowClear placeholder="全部" style={{ width: 100 }} onChange={ this.changeValue.bind(this,'onLineC')}>
                                    <Option key='0' value='-1'>
                                        全部
                                    </Option>
                                    <Option key='1' value='1'>
                                        在线
                                    </Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={1} offset={4}>
                        <FormItem label="类型" >
                            {getFieldDecorator('os')(
                                <Select allowClear placeholder="全部" style={{ width: 100 }} onChange={this.changeValue.bind(this,'osC')}>
                                    <Option key='0' value='-1'>
                                        全部
                                    </Option>
                                    <Option key='1' value={'ios'}>
                                        ios
                                    </Option>
                                    <Option key='2' value={'android'}>
                                        android
                                    </Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="目标客户端">
                            {getFieldDecorator('clientIds')(
                                <Transfer
                                    titles={['待选数据', '选中数据']}
                                    dataSource={listAllChild}
                                    showSearch
                                    filterOption={this.filterOption}
                                    targetKeys={selectedRowKeys}
                                    onChange={this.handleChange}
                                    render={this.renderItem}
                                />)}
                        </FormItem>
                    </Col>

                </Row>
            </Form>
        );
        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.clientList.list.reduce((a, b) => (b.clientId === state.clientList.currentSelectId ? b : a), {}),
    isModalShow: state.clientList.uiStatus.isSendCommend,
    isLoading: state.clientList.uiStatus.isLoading,

    listAllChild: state.clientList.listAllChild,
    transferData: state.clientList.transferData,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isSendCommend: false })),
    reStart: contents => dispatch(reStart(contents)),
    asyncGetAll: () => dispatch(asyncGetAll()),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    asyncGet: () => dispatch(asyncGet()),
    changeTrankerSource: (onLineC,osC) => dispatch(changeTrankerSource(onLineC,osC)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(SetOrder));



// WEBPACK FOOTER //
// ./pages/client/clientList/setOrder.js